import { render, staticRenderFns } from "./shmu-icon.vue?vue&type=template&id=7bf97546&"
import script from "./shmu-icon.vue?vue&type=script&lang=js&"
export * from "./shmu-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports